var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.level)?_c('i',{class:['k-badge-level', ("badge-" + (_vm.level.stage) + "-" + (_vm.level.level))]}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }